'use client';

import { TOtpConfig } from '@features/otpHandler';
import { useMobile } from '@shared/hooks';

import { useUserInfoStore } from '../../user';
import { useSejamCheckStore } from '@shared/store';
import { useConfirmSejamOtp, useSendSejamOtp } from './hook';
import { ToastService } from '@shared/ui';
import { sejamCheckText } from './languages';

export const useSejamCheck = () => {
  const isMobile = useMobile();
  const userinfoStore = useUserInfoStore((store) => store.data);
  const { isOpen: openModal, setOpen: setOpenModal } = useSejamCheckStore((store) => store);

  const shouldUpdate = userinfoStore?.isSejami && !userinfoStore?.hasUpdatedSejamInfo;

  const sendSejamOtp = useSendSejamOtp(() => {
    setOpenModal(false);
  });
  const confirmSejamOtp = useConfirmSejamOtp(() => {
    ToastService.success(sejamCheckText.updateSejamInfoSuccess);
  });

  const SendOtp = () => {
    sendSejamOtp.mutate();
  };

  const otpConfig: TOtpConfig = {
    open: sendSejamOtp.isSuccess,
    length: 5,
    expirationDate: sendSejamOtp.data?.expirationDate,
    expirationInSeconds: sendSejamOtp.data?.expirationInMinutes
      ? sendSejamOtp.data?.expirationInMinutes * 60
      : undefined,

    send: {
      isPending: sendSejamOtp.isPending,
      isSuccess: sendSejamOtp.isSuccess,
    },

    resend: {
      action: sendSejamOtp.reset,
      isPending: sendSejamOtp.isPending,
      isSuccess: sendSejamOtp.isSuccess,
    },

    confirm: {
      action: (otpValue: string) => {
        confirmSejamOtp.mutate({
          otp: otpValue,
          token: sendSejamOtp.data?.token!!,
        });
      },
      isPending: confirmSejamOtp.isPending,
      isSuccess: confirmSejamOtp.isSuccess,
      error: confirmSejamOtp.error?.errors[0]?.message,
      reset: confirmSejamOtp.reset,
    },

    onClose: () => {},
  };

  return {
    isMobile,
    modal: {
      open: openModal,
      setOpen: setOpenModal,
    },
    shouldUpdate,
    otpConfig,
    action: {
      SendOtp,
    },
  };
};
